export interface LoggedPerson {
  nome?: string;
  sobrenome?: string;
  foto?: string;
  primeiroAcesso?: boolean;
}

/**
 * `nome + " " + sobrenome` quando ambos presentes; apenas `nome` quando o
 * sobrenome está ausente/vazio; `null` quando não há `nome` ou a pessoa é `null`.
 */
export function buildPersonName(person: LoggedPerson | null): string | null {
  if (!person || !person.nome) {
    return null;
  }

  if (person.sobrenome) {
    return `${person.nome} ${person.sobrenome}`;
  }

  return person.nome;
}
